import type { ActiveFilters } from "hsl-core/FundExplorer";
import { getEntityLocalID } from "hsl-core/utils";

export default function getOpenFunds(filters: ActiveFilters) {
	const fundIds = filters["fund.id"];
	return fundIds ? fundIds.map((id) => getEntityLocalID("fund", id)) : [];
}
